import React from "react";
import Index from "../_components/Notification/Index"

function NotificationPage() {
    return <Index />
}

export default NotificationPage;